import { axios } from '@/utils/request'

export function addScore (obj) {
  return axios({
    url: '/HomeworkStudent',
    method: 'post',
    data: obj
  })
}

export function delBatchRecord (ids) {
  return axios({
    url: '/HomeworkRecord/deleteBatch/' + ids,
    method: 'delete'
  })
}

export function addRecordList (list) {
  return axios({
    url: '/HomeworkRecord/saveList',
    method: 'post',
    data: list
  })
}

export function addHistoryList (list) {
  return axios({
    url: '/HomeworkHistory/saveList',
    method: 'post',
    data: list
  })
}

export function getRankList (queryParam) {
  return axios({
    url: '/homework/rankList',
    method: 'get',
    params: queryParam
  })
}

export function getWordList (queryParam) {
  return axios({
    url: '/homework/word',
    method: 'get',
    params: queryParam
  })
}

export function getSpeakList (queryParam) {
  return axios({
    url: '/homework/speak',
    method: 'get',
    params: queryParam
  })
}

export function getSymbolList (queryParam) {
  return axios({
    url: '/homework/symbol',
    method: 'get',
    params: queryParam
  })
}
